import { render, staticRenderFns } from "./manage-user-roles-modal.vue?vue&type=template&id=199cea3b&"
import script from "./manage-user-roles-modal.vue?vue&type=script&lang=js&"
export * from "./manage-user-roles-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports